import * as types from 'modules/questionModels/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} State */
const initialState = false;

const isStarted = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [types.CLONE_QUESTION_MODEL]: isStarted,
  [types.CLONE_QUESTION_MODEL_SUCCESS]: isEnded,
  [types.CLONE_QUESTION_MODEL_FAILURE]: isEnded,
});
